// App
import React from 'react';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

// Hooks
import { useFilterChange } from 'app/shared/modules/filter/FilterBar/hooks';

// Styles
import { css } from '@/styled-system/css';

const clearFiltersButtonStyle = css({
  fontSize: 'tiny',
});

const ClearAllFiltersButton = () => {
  // Hooks
  const { resetFilter } = useFilterChange();

  const handleClearButtonClick = () => {
    resetFilter(null);
  };

  return (
    <ButtonBase buttonType="link" className={clearFiltersButtonStyle} onClick={handleClearButtonClick}>
      Clear all filters
    </ButtonBase>
  );
};

export default ClearAllFiltersButton;
